import { privateAxiosIntance } from "../../Config/axios";
import { API_URLS } from "../../Config/urls";


export const getAllImagesFn = () => {
    try {
        const response = privateAxiosIntance.get(API_URLS.allimages);
        return response;
    } catch (error) {
        throw error;
    }
}

export const postAllImagesFn = (req) => {
    try {
        const response = privateAxiosIntance.post(API_URLS.allimages,req);
        return response;
    } catch (error) {
        throw error;
    }
}

export const PatchAllImagesFn = (req) => {
    try {
        const response = privateAxiosIntance.patch(API_URLS.allimages,req);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteAllImagesFn = (req) => {
    try {
        const response = privateAxiosIntance.delete(API_URLS.allimages,{
            data:req
        });
        return response;
    } catch (error) {
        throw error;
    }
}